import { Controller } from '@hotwired/stimulus';

export const create = (options) => {
	return class extends Controller {
		connect() {
			console.log('test controller loaded', performance.now(), options);
		}
	};
};
